/**
 * Class @LocalStorageService for managing localStorage items.
 * Provides methods set, get, remove, has and clear for managing items in localStorage.
 */
class LocalStorageService {
  /**
   * Conststructor for wrapper service class to the localStorage.
   * Assigns to the this.storage proeperty localStorage refference.
   * @constructor
   *
   */
  constructor() {
    this.storage = window.localStorage;
  }

  /* eslint-disable max-len */
  /**
   * Set item in localStorage with key and value.
   *
   * @param {string} key Is the key of item that will be stored in localStorage.
   * @param {string} value Is the value to be stored in localStorage, value is string if should be stored some complex data like
   * object before calling this method object should be stringified by using JSON.stringify.
   * @return {object} Returns this reference.
   */
  /* eslint-enable max-len */
  set = (key, value) => {
    this.storage.setItem(key, value);

    return this;
  };

  /**
   * Get item from localStorage by provided key.
   *
   * @param {string} key Is key of item which should be found in localStorage.
   * @return {string} Returns founded item from localStorage, is string value.
   * After receiving this string value if is exoexted complex data like json,
   * caller should use JSON.parse to get object representation of data.
   */
  get = (key) => this.storage.getItem(key);

  /**
   * Removes item from localStorage.
   *
   * @param {string} key Is the key of item to be removed.
   * @return {object} Returns this reference.
   */
  remove = (key) => {
    this.storage.removeItem(key);

    return this;
  };

  /**
   * Has property check method to check if item with key exist in localStorage.
   *
   * @param {string} key Is key of item to be checked if exist in localStorage.
   * @return {boolean} Returns true if item with key exists in localStorage, if not exists false is returned.
   */
  has = (key) => Object.hasOwn(this.storage, key);

  /**
   * Clear all items from localStorage.
   *
   * @return {object} Returns this reference.
   */
  clear = () => {
    this.storage.clear();

    return this;
  };
}

export default new LocalStorageService();
